var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "zixunxiangqinmg" },
    [
      _c(
        "div",
        { staticClass: "new_top" },
        [_c("header2"), _vm._v(" "), _c("navigation")],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "sy_main" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "sym_content2" }, [
          _c("div", { staticClass: "symc3" }, [
            _c("div", { staticClass: "symc3_main" }, [
              _c("div", { staticClass: "symc3_box" }, [
                _c("div", { staticClass: "symc3_box_title" }, [
                  _c("p", { staticClass: "detail_title" }, [
                    _vm._v(_vm._s(_vm.newsInfo.newsTitle))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "detail_info" }, [
                    _c("span", [
                      _vm._v("来源：" + _vm._s(_vm.newsInfo.newsSource))
                    ]),
                    _c("span", [
                      _vm._v("发布日期：" + _vm._s(_vm.newsInfo.publishTime))
                    ]),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "javascript:;",
                          onClick: "window.print();"
                        }
                      },
                      [_vm._v("【打印本页】")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "symc3_box_main",
                    staticStyle: { "min-height": "200px" }
                  },
                  [
                    _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.newsInfo.content) }
                    })
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "symc_right" },
            [_c("login"), _vm._v(" "), _c("latestNewsSimple")],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", {})
      ]),
      _vm._v(" "),
      _c("footer1")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sy_position" }, [
      _vm._v("您当前的位置："),
      _c("a", { attrs: { href: "#" } }, [_vm._v("首页")]),
      _vm._v(" >> 资讯详情")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77d95bdb", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77d95bdb","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/NewsInfo.vue
// module id = null
// module chunks = 